import { Inject, Injectable, Injector, PLATFORM_ID } from '@angular/core';
import { CountryCode } from '../../models/utils/common-support.interfaces';
import { environmentObject } from '../../models/utils/object.interfaces';
import { ApplicationConfig } from '../config';
import { WindowRef } from './helpers';

@Injectable({
  providedIn: 'root'
})
export class UrlUtilExtended {
  public _customerUrl!: string;
  countryCodeConfig: CountryCode = {} as CountryCode;
  public _requestHost!: string;
  public _requestProtocol!: string;
  public _hostname!: string;

  constructor(
    public injector: Injector,
    // eslint-disable-next-line @typescript-eslint/ban-types
    @Inject(PLATFORM_ID) public platformId: Object,
    public config: ApplicationConfig,
    public winRef: WindowRef
  ) {
    const url_mapping = this.config.get('APP_URL_MAPPINGS');
    if (url_mapping) {
      this.countryCodeConfig = JSON.parse(url_mapping);
    }
  }

  public _hostUrl!: string;

  /**
   * returns the HOST URL without the APP WEB CONTEXT
   * e.g. https://localhost:9000 or http://localhost:9000
   */
  get hostUrl() {
    return `//${window.location.host}`;
  }

  getBase(): string {
    return this._requestHost ? this._requestHost.split(':')[1] : '';
  }

  getAEM(environment: environmentObject): string {
    return environment.isLocal
      ? this._hostUrl
      : `${this._requestProtocol}://${environment.webserverHostname}`;
  }

  getHostName(environment: environmentObject): string {
    return environment.isLocal ? this._requestHost : this._hostname;
  }

  getCustomerUrl(environment: environmentObject): string {
    return environment.isLocal
      ? this._hostUrl
      : `${this._requestProtocol}://${environment.customerJvm}`;
  }

  getUtilUrl(environment: environmentObject): string {
    return environment.isLocal
      ? this._hostUrl
      : `${this._requestProtocol}://${environment.UtilJvm}`;
  }

  getCountryCodeForUrl(countryCode: string): string {
    if (
      this.countryCodeConfig &&
      countryCode &&
      this.countryCodeConfig[countryCode]
    ) {
      return this.countryCodeConfig[countryCode];
    }
    return this.config.get('APP_DEFAULT_COUNTRY');
  }
}
